__turbopack_context__.v({
  "centered": "modal-module-scss-module__QmjLbG__centered",
  "closeX": "modal-module-scss-module__QmjLbG__closeX",
  "container": "modal-module-scss-module__QmjLbG__container",
  "content": "modal-module-scss-module__QmjLbG__content",
  "ctaGroup": "modal-module-scss-module__QmjLbG__ctaGroup",
  "headerGroup": "modal-module-scss-module__QmjLbG__headerGroup",
  "headline": "modal-module-scss-module__QmjLbG__headline",
  "medium": "modal-module-scss-module__QmjLbG__medium",
  "modal": "modal-module-scss-module__QmjLbG__modal",
  "opened": "modal-module-scss-module__QmjLbG__opened",
  "overflowHidden": "modal-module-scss-module__QmjLbG__overflowHidden",
  "overlay": "modal-module-scss-module__QmjLbG__overlay",
  "plancard": "modal-module-scss-module__QmjLbG__plancard",
  "small": "modal-module-scss-module__QmjLbG__small",
  "subhead": "modal-module-scss-module__QmjLbG__subhead",
  "transparentBackground": "modal-module-scss-module__QmjLbG__transparentBackground",
  "video": "modal-module-scss-module__QmjLbG__video",
});
